// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_kq-0";
export var animationContainer = "_kq-1";
export var itemPrice = "_kq-a";
export var itemizedContent = "_kq-9";
export var itemizedHeader = "_kq-7";
export var itemizedRow = "_kq-8";
export var itemizedSection = "_kq-6";
export var modalContent = "_kq-2";
export var orderName = "_kq-3";
export var refundOption = "_kq-4";
export var refundOptionsContainer = "_kq-5";
export var shippingLabel = "_kq-b";
export var totalRow = "_kq-c";